
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/house-history-genealogy",
      function () {
        return require("private-next-pages/articles/house-history-genealogy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/house-history-genealogy"])
      });
    }
  